import React, { Component } from 'react';
import dayjs from 'dayjs';

import { LubesCategoryList, ProductList } from '@C/Lubes/_utils/';
import services from '@C/Reports/_utils/data';
import { formatCurrency, TableGrid } from '@C/TableGrid';
import { PaymentMethodInfo, StaffList, DateRangeFilter } from '@C/Utils';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';

const col = [
  {
    name: 'Date',
    key: 'time_stamp',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Bill No',
    key: 'payment_for',
    formatter(props) {
      return <>{props.bill_number}</>;
    },
  },
  {
    name: 'Product',
    key: 'payment_for',
    formatter(props) {
      return <>{props.name}</>;
    },
  },
  {
    name: 'Rate',
    key: 'payment_for',
    formatter(props) {
      return <>{formatCurrency(props.selling_price)}</>;
    },
  },
  {
    name: 'Qty',
    key: 'payment_for',
    formatter(props) {
      return <>{formatCurrency(props.quantity)}</>;
    },
  },
  {
    name: 'Discount',
    key: 'payment_for',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.discount)}</>;
    },
  },
  {
    name: 'Amount (Excl Tax)',
    type: 'currency',
    key: 'payment_for',
    formatter(props) {
      return <>{formatCurrency(props.after_discount)}</>;
    },
  },
  {
    name: 'Amount (Inc Tax)',
    type: 'currency',
    key: 'payment_for',
    formatter(props) {
      return <>{formatCurrency(props.after_tax)}</>;
    },
  },
  {
    name: 'Payment mode',
    key: 'payment_method',
    type: 'payment',
    formatter(props) {
      return (
        <>
          <PaymentMethodInfo
            source={props.source}
            method={props.payment_method}
            bank={props.bank}
            wallet={props.other_wallet}
          />
        </>
      );
    },
  },
  {
    name: 'Staff',
    key: 'cashier',
    formatter(props) {
      return (
        <>
          {props.first_name} {props.last_name}
        </>
      );
    },
  },
  {
    name: 'Notes',
    key: 'notes',
  },
];

class CombinedLubesSalesReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slipList: [],
      product_uuid: '',
      lube_category: '',
      staff_id: '',
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      loading: false,
      limit: 20,
      offset: 1,
      count: 0,
      showAll: 0,
    };
    this.limitInput = React.createRef();
  }

  handleQuickSearch = (e) => {
    e.preventDefault();
    if (
      this.limitInput.current.value === '' ||
      this.limitInput.current.value === '0'
    ) {
      return;
    }
    this.setState(
      { limit: this.limitInput.current.value, offset: 1 },
      function () {
        this.getCombinedLubeSalesReport();
      },
    );
  };

  componentDidMount() {
    // this.getCombinedLubeSalesReport();
  }

  handleProductChange = (e, i) => {
    this.setState({ product_uuid: e?.value || '' });
  };

  handleCategoryChange = (e) => {
    this.setState({ lube_category: e.value });
  };

  handleStaffChange = (e) => {
    this.setState({ staff_id: e.value });
  };

  getCombinedLubeSalesReport = () => {
    services
      .getCompleteLubeSalesReport(this.state)
      .then((response) => {
        this.setState({
          slipList: response.data.data.results,
          count: response.data.data.count,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handlePagination = (e) => {
    this.setState({ offset: e }, function () {
      this.getCombinedLubeSalesReport();
    });
  };

  handleDateChange = (e) => {
    const { name, value } = e.target;
    const maxRangeMonths = 6;

    if (name === 'start_date') {
      const newStartDate = dayjs(value);
      const currentEndDate = dayjs(this.state.end_date);
      const maxEndDate = newStartDate.add(maxRangeMonths, 'month');

      // If new start date is after current end date, set end date to start date
      if (newStartDate.isAfter(currentEndDate)) {
        this.setState({ start_date: value, end_date: value });
      }
      // If end date exceeds 6 months from new start date, adjust end date
      else if (currentEndDate.isAfter(maxEndDate)) {
        this.setState({
          start_date: value,
          end_date: maxEndDate.format('YYYY-MM-DD'),
        });
      }
      // Otherwise just update start date
      else {
        this.setState({ start_date: value });
      }
    } else if (name === 'end_date') {
      const newEndDate = dayjs(value);
      const currentStartDate = dayjs(this.state.start_date);
      const minStartDate = newEndDate.subtract(maxRangeMonths, 'month');

      // If new end date is before current start date, set start date to end date
      if (newEndDate.isBefore(currentStartDate)) {
        this.setState({ end_date: value, start_date: value });
      }
      // If start date is more than 6 months before new end date, adjust start date
      else if (currentStartDate.isBefore(minStartDate)) {
        this.setState({
          end_date: value,
          start_date: minStartDate.format('YYYY-MM-DD'),
        });
      }
      // Otherwise just update end date
      else {
        this.setState({ end_date: value });
      }
    }
  };

  resetFilter = () => {
    this.limitInput.current.value = 20;
    this.setState(
      {
        staff_id: '',
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        product_uuid: '',
        lube_category: '',
        loading: false,
        limit: 20,
        offset: 1,
      },
      function () {
        //this.getCombinedLubeSalesReport();
      },
    );
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true, offset: 1 }, function () {
      this.getCombinedLubeSalesReport();
    });
  };

  render() {
    const { slipList } = this.state;

    return (
      <section className="widget full-width list-table inverted">
        <header>
          <h3>Combined Lube / Products Sales Report</h3>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group">
                <label>Date range:</label>
                <DateRangeFilter
                  value={[this.state.start_date, this.state.end_date]}
                  onChange={(dates) => {
                    this.setState({
                      start_date: dates[0],
                      end_date: dates[1],
                    });
                  }}
                  limit={6}
                />
              </div>

              <div className="filter-group">
                <label>Staff:</label>
                <StaffList
                  value={this.state.staff_id}
                  onChange={this.handleStaffChange}
                  staffType={['Cashiers', 'Managers', 'Dealer']}
                />
              </div>
              <div className="filter-group">
                <label>Product:</label>
                <ProductList
                  handleDropdownChange={this.handleProductChange}
                  value={this.state.product_uuid}
                  isShowDeleted={true}
                />
              </div>
              <div className="filter-group">
                <label>Category:</label>
                <LubesCategoryList
                  handleDropdownChange={this.handleCategoryChange}
                  value={this.state.lube_category}
                />
              </div>

              <div className="filter-group with-icon">
                <label>
                  Results to display- {this.state.limit || 20} (Total:{' '}
                  {this.state.count})
                </label>
                <form onSubmit={this.handleQuickSearch}>
                  <input type="text" name="limit" ref={this.limitInput} />
                  <button
                    type="submit"
                    className="search-icon"
                    onClick={this.handleQuickSearch}
                  />
                </form>
              </div>
              <div className="filter-group reset-filter">
                <button onClick={this.resetFilter}>Reset filters</button>
              </div>
              <div className="filter-group">
                <button
                  className={`submit ${this.state.loading ? 'loading' : ''}`}
                  disabled={this.state.loading}
                  type="submit"
                  onClick={this.submitForm}
                >
                  Generate Report
                </button>
              </div>
            </div>
          </div>
          <div className="table-wrapper">
            <div className="mini-summary">
              <ul>
                <li>
                  <span> Total amount (Excl tax): </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {}).format(
                      slipList
                        .reduce(
                          (a, b) =>
                            a + (b['payment_for']['after_discount'] || 0),
                          0,
                        )
                        .toFixed(2) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span> Total amount (Incl tax): </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {}).format(
                      slipList
                        .reduce(
                          (a, b) => a + (b['payment_for']['after_tax'] || 0),
                          0,
                        )
                        .toFixed(2) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span> Total discount: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {}).format(
                      slipList
                        .reduce(
                          (a, b) => a + (b['payment_for']['discount'] || 0),
                          0,
                        )
                        .toFixed(2) || 0,
                    )}
                  </span>
                </li>
              </ul>
            </div>

            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <TableGrid
                    col={col}
                    row={slipList}
                    offset={this.state.offset}
                    count={this.state.count}
                    limit={this.state.limit}
                    handlePagination={this.handlePagination}
                    hideActions={true}
                    exportOptions={{
                      fileName: `Combined Lubes Sales - ${this.state.start_date} to ${this.state.end_date}.pdf`,
                      reportName: 'Combined Lubes Sales Report',
                      reportDate: `Date - ${dayjs(this.state.start_date).format(
                        'D MMM YY',
                      )} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                      reportTotal: `Total amount -  ${
                        slipList
                          .reduce(
                            (a, b) => a + (b['payment_for']['after_tax'] || 0),
                            0,
                          )
                          .toFixed(2) || 0
                      }`,
                      reportQuantity: `Total discount -  ${
                        slipList
                          .reduce(
                            (a, b) => a + (b['payment_for']['discount'] || 0),
                            0,
                          )
                          .toFixed(2) || 0
                      }`,
                      reportSales: '',
                      reportTesting: '',
                      reportBowser: '',
                      reportCustomerName: '',
                      reportGst: '',
                      reportOpeningBalance: '',
                      reportClosingBalance: '',
                      reportSaleTotal: '',
                      reportTCSTotal: '',
                    }}
                  />
                );
              }
            })()}
          </div>
        </main>
      </section>
    );
  }
}

export { CombinedLubesSalesReport };
